import { gql } from '@apollo/client';

export const FLUSH_CACHE = gql`
  mutation flushRedisCache($input: FlushRedisCacheInput!) {
    flushRedisCache(input: $input) {
      flushedEntities
    }
  }
`;
